const documentToPlainTextString = require('@contentful/rich-text-plain-text-renderer').documentToPlainTextString;

module.exports = function calculateReadTime(text) {
    return Math.ceil(documentToPlainTextString(text).length / (200 * 6));
};